module.exports = __webpack_public_path__ + "img/buttonimg.0bcbe86f.png";